const initialState = {
    searchData: [],
    ansStapled: [],
    isLoadingSearchData:null
}

const knowledgeEntryPageReducer = (state = initialState, action) => {
    switch (action.type) {
        case "getsearchdataforknowledgeEntry":
            state = { ...state, searchData: action.payload }
            return state;
        case "getstapledanswer":
            state = { ...state, ansStapled: action.payload }
            return state;
        case "dataloadingsuggestions":
            state = { ...state, isLoadingSearchData: action.payload }
            return state;
        case "emptystateafterclick":
            return initialState;
        default:
            return state;
    }
}

export default knowledgeEntryPageReducer;